import { ATTRIBUTE_PRODUCT_TYPE } from "../../constants/attributeTypes.js";

export const triggerAttributes = {
  SELECT_PRODUCTS_BASED_ON_HAVE_TAG: "Has a specific tag",
  SELECT_PRODUCTS_BASED_ON_DOES_NOT_HAVE_TAG: "Does not have a specific tag",
  SELECT_PRODUCTS_BASED_ON_MULTIPLE_CONDITIONS: "Multiple conditions",
  ATTRIBUTE_TITLE: "Title",
  ATTRIBUTE_DESCRIPTION: "Description",
  ATTRIBUTE_BRAND: "Brand",
  ATTRIBUTE_PRODUCT_TYPE: "Product type",
  ATTRIBUTE_PRICE: "Price",
  ATTRIBUTE_PICTURE: "Picture",
  ATTRIBUTE_INVENTORY: "Inventory",
  ATTRIBUTE_TAGS: "Tags",
  ATTRIBUTE_PRODUCT_STATUS: "Status",
  ATTRIBUTE_PRODUCT_CATEGORY: "Product category",
  VARIANT_ATTRIBUTE_SKU: "SKU",
  VARIANT_ATTRIBUTE_WEIGHT: "Weight",
  VARIANT_ATTRIBUTE_BARCODE: "Barcode",
  VARIANT_ATTRIBUTE_TAXABLE: "Taxable",
  VARIANT_ATTRIBUTE_INVENTORY_POLICY: "Inventory policy",
  VARIANT_ATTRIBUTE_ITEM_COST: "Unit cost",
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION: "Locations count",
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME: "Inventory locations",
};